function HttpIntercept() {
  // eslint-disable-next-line
  const callbacks = Array.prototype.slice.call(arguments);

  return req => {
    const callback = req.callback;

    req.callback = (err, res) => {
      callbacks.forEach(e => {
        e.call(req, err, res);
      });

      callback.call(req, err, res);
    };
  };
}

export default HttpIntercept;



// WEBPACK FOOTER //
// ./api/httpIntercept.js